@let val = value();
<table class="gender-table">
  <thead>
    <tr>
      <th></th>
      <th>Upper</th>
      <th>Lower</th>
      <th>Std dev</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <th>Male</th>
      @if (val.kind === 'pace') {
        @for (field of maleFields; track field) {
          <td>
            <tui-textfield tuiTextfieldSize="s" [tuiTextfieldCleaner]="false">
              <input
                tuiInput
                [maskito]="mask"
                placeholder="m:ss.s"
                [disabled]="!editable()"
                [invalid]="fieldInvalid(field)"
                [ngModel]="val[field]"
                (ngModelChange)="updatePaceField(field, $event)"
              />
            </tui-textfield>
          </td>
        }
      } @else {
        @for (field of maleFields; track field) {
          <td>
            <tui-textfield tuiTextfieldSize="s" [tuiTextfieldCleaner]="false">
              <input
                tuiInputNumber
                [disabled]="!editable()"
                [invalid]="fieldInvalid(field)"
                [ngModel]="val[field]"
                (ngModelChange)="updateNumberField(field, $event)"
              />
            </tui-textfield>
          </td>
        }
      }
    </tr>

    <tr>
      <th>Female</th>
      @if (val.kind === 'pace') {
        @for (field of femaleFields; track field) {
          <td>
            <tui-textfield tuiTextfieldSize="s" [tuiTextfieldCleaner]="false">
              <input
                tuiInput
                [maskito]="mask"
                placeholder="m:ss.s"
                [disabled]="!editable()"
                [invalid]="fieldInvalid(field)"
                [ngModel]="val[field]"
                (ngModelChange)="updatePaceField(field, $event)"
              />
            </tui-textfield>
          </td>
        }
      } @else {
        @for (field of femaleFields; track field) {
          <td>
            <tui-textfield tuiTextfieldSize="s" [tuiTextfieldCleaner]="false">
              <input
                tuiInputNumber
                [disabled]="!editable()"
                [invalid]="fieldInvalid(field)"
                [ngModel]="val[field]"
                (ngModelChange)="updateNumberField(field, $event)"
              />
            </tui-textfield>
          </td>
        }
      }
    </tr>
  </tbody>
</table>
